import React, { useEffect, useState } from 'react';
import NavBars from '../Sidebar/Sidebar';
import './protected.css';
import { db } from '../../firebase';
import { collection, deleteDoc, getDocs, setDoc, doc, getDoc, updateDoc, query, where, addDoc } from 'firebase/firestore';
import Popup from 'reactjs-popup';
import { CSSTransition } from 'react-transition-group';
import './message.css'; // Import the CSS file for the fade effect
import { UserAuth, fetchAdminPassword } from '../../authContext'; // Assuming this is where your AuthContext is defined
import { FaPlus, FaEdit } from 'react-icons/fa';

const Items = () => {
  const [items, setItems] = useState([]);
  const [message, setMessage] = useState('');
  const [showMessage, setShowMessage] = useState(false);
  const [projects, setProjects] = useState([]);
  const [showNewItemModal, setShowNewItemModal] = useState(false); // State to toggle new item modal visibility
  const { user } = UserAuth(); // Get the current user from the AuthContext
  const [showEditModal, setShowEditModal] = useState(false);
  const [selectedItem, setSelectedItem] = useState(null); // State to store the item to be edited
  const [isAdmin, setIsAdmin] = useState(false);

  useEffect(() => {
      const checkAdminStatus = async () => {
          try {
              // Simulate a delay to fetch user info
              const storedUser = JSON.parse(localStorage.getItem('user'));
              const storedIsAdmin = localStorage.getItem('isAdmin') === 'true';

              if (storedUser && storedUser.email === user?.email) {
                  setIsAdmin(storedIsAdmin);
              } else {
                  setIsAdmin(false);
              }
          } catch (error) {
              console.error("Failed to fetch admin status:", error);
              setIsAdmin(false);
          } 
      };

      if (user) {
          checkAdminStatus();
      } 
  }, [user]);
  useEffect(() => {
    const fetchData = async () => {
      const itemsCollection = collection(db, 'Items');
      const itemsSnapshot = await getDocs(itemsCollection);
      const itemsList = itemsSnapshot.docs.map(doc => ({
        id: doc.id,
        ...doc.data()
      }));
      setItems(itemsList);

      // Fetch projects once when the component mounts
      if (user) {
        const q = query(collection(db, 'users'), where('email', '==', user.email));
        const querySnapshot = await getDocs(q);
        if (!querySnapshot.empty) {
          const userData = querySnapshot.docs[0].data();
          const projectPromises = userData.projects.map(async projectRef => {
            const projectDoc = await getDoc(projectRef);
            return projectDoc.exists() ? { id: projectDoc.id, ...projectDoc.data() } : null;
          });
          const projectResults = await Promise.all(projectPromises);
          setProjects(projectResults.filter(project => project !== null));
        }
      }

      // Check if there's a message to show
      const storedMessage = sessionStorage.getItem('message');
      if (storedMessage) {
        setMessage(storedMessage);
        setShowMessage(true);
        sessionStorage.removeItem('message');
        setTimeout(() => {
          setShowMessage(false);
        }, 5000); // Show message for 5 seconds
      }
    };

    fetchData();
  }, [user]);

  const handleReserve = async (itemId, reserveAmount, selectedProjectId) => {
    if (!itemId) {
      console.error("Item ID is undefined.");
      return;
    }

    const itemDocRef = doc(db, 'Items', itemId);
    const projectDocRef = doc(db, 'Projects', selectedProjectId);

    try {
      const itemDoc = await getDoc(itemDocRef);
      const projectDoc = await getDoc(projectDocRef);

      if (itemDoc.exists() && projectDoc.exists()) {
        const itemData = itemDoc.data();
        const projectData = projectDoc.data();

        const projectItem = projectData.items.find(item => item.itemId === itemId);
        const currentReserveAmount = projectItem ? projectItem.reserveAmount : 0;

        if (itemData.AvailQuantity < reserveAmount) {
          sessionStorage.setItem('message', 'Unable to process, insufficient amount in stock');
        } else {
          await updateDoc(itemDocRef, {
            AvailQuantity: itemData.AvailQuantity - reserveAmount,
            ResQuantity: itemData.ResQuantity + reserveAmount
          });

          const updatedItems = [
            ...projectData.items.filter(item => item.itemId !== itemId),
            { itemId, reserveAmount: currentReserveAmount + reserveAmount }
          ];

          await updateDoc(projectDocRef, {
            items: updatedItems
          });

          setItems(prevItems =>
            prevItems.map(item =>
              item.id === itemId
                ? {
                    ...item,
                    AvailQuantity: item.AvailQuantity - reserveAmount,
                    ResQuantity: item.ResQuantity + reserveAmount
                  }
                : item
            )
          );
          const projectName = projectData.name;
          sessionStorage.setItem('message', `Reserved item/s successfully for project "${projectName}"`);
        }

        setMessage(sessionStorage.getItem('message'));
        setShowMessage(true);
        setTimeout(() => {
          setShowMessage(false);
        }, 5000); // Show message for 5 seconds
      } else {
        console.log("Item or Project does not exist.");
      }
    } catch (error) {
      console.error("Error fetching document:", error);
    }
  };

  const handleNewItemClick = async () => {
    setShowNewItemModal(true);
};


  const addNewItem = async ({ name, image, totalQuantity, documentation }) => {
    try {
      if (!name || !image || !totalQuantity) {
        setMessage('Please fill out all required fields.');
        setShowMessage(true);
        setTimeout(() => {
          setShowMessage(false);
        }, 5000);
        return;
      }

      await addDoc(collection(db, 'Items'), {
        Name: name,
        image,
        TotalQuantity: totalQuantity,
        Documentation: documentation || '',
      });

      setMessage('New item added successfully');
      setShowNewItemModal(false);

      setItems(prevItems => [...prevItems, { Name: name, image, TotalQuantity: totalQuantity, Documentation: documentation || '' }]);
    } catch (error) {
      console.error('Error adding new item:', error);
      setMessage('Failed to add new item');
    } finally {
      setShowMessage(true);
      setTimeout(() => {
        setShowMessage(false);
      }, 5000);
    }
  };

  const handleEditItemClick = async (item) => {
    try {
      setSelectedItem(item); // Set the selected item for editing
      setShowEditModal(true);
    } catch (error) {
        console.error("Error fetching admin password:", error);
        alert('Failed to verify password. Please try again later.');
    }
};


  const handleDeleteItemClick = async (itemId) => {
      setShowEditModal(false);
      await deleteDoc(doc(db, 'Items', itemId));
      setMessage('Item deleted successfully');
      setItems(prevItems => prevItems.filter(item => item.id !== itemId));
      
  };

  const editItem = async (itemId, name, image, totalQuantity, documentation) => {
    try {
      const itemDocRef = doc(db, 'Items', itemId);
      
      await updateDoc(itemDocRef, {
        Name: name,
        image,
        TotalQuantity: totalQuantity,
        AvailQuantity: totalQuantity,
        Documentation: documentation || '',
      });
      setMessage('Item updated successfully');
      setShowEditModal(false);

      setItems(prevItems =>
        prevItems.map(item =>
          item.id === itemId
            ? { ...item, Name: name, image, TotalQuantity: totalQuantity, Documentation: documentation || '' }
            : item
        )
      );
    } catch (error) {
      console.error('Error updating item:', error);
      setMessage('Failed to update item');
    } finally {
      setShowMessage(true);
      setTimeout(() => {
        setShowMessage(false);
      }, 5000);
    }
  };

  const getMessageStyle = () => {
    return {
      position: 'fixed',
      top: '50%',
      left: '50%',
      transform: 'translate(-50%, -50%)',
      padding: '20px',
      backgroundColor: 'white',
      border: `1px solid ${message.includes('successfully') ? 'green' : 'red'}`,
      color: message.includes('successfully') ? 'green' : 'red',
      fontWeight: 'bold',
      zIndex: 1000,
    };
  };

  return (
    <div>
      <CSSTransition
        in={showMessage}
        timeout={1000}
        classNames="fade"
        unmountOnExit
      >
        <div style={getMessageStyle()}>
          {message}
        </div>
      </CSSTransition>
      <div className='content'>
        <div className='grid-container'>
          {items.length ? (
            items.map(item => (
              <div key={item.id} className="item" onDoubleClick={isAdmin ? () => handleEditItemClick(item):null}>
                {item.Documentation && item.Documentation.includes('http') ? (
              <a href={item.Documentation} className='item-name' target="_blank" rel="noopener noreferrer">
                {item.Name}
              </a>
                ) : (
                  <span className='item-name'>
                    {item.Name}
                  </span>
                )}
                <img className="feild" src={item.image} alt={item.Name} style={{ width: 'auto', height: '120px' }} />
                <p className="feild" >Available Quantity: {item.TotalQuantity}</p>
              </div>
            ))
          ) : (
            <p>Loading...</p>
          )}
          { isAdmin && <button 
                                className="floating-button"                       
                                  onClick={handleNewItemClick}
                              >
                                <FaPlus style={{ color: 'white' }} />
                              </button>}
        </div>
        
        <Popup open={showNewItemModal} onClose={() => setShowNewItemModal(false)}>
          <div className="modal">
            <h2>Add New Item</h2>
            <NewItemForm onSubmit={addNewItem} onCancel={() => setShowNewItemModal(false)} />
          </div>
        </Popup>
        <Popup open={showEditModal} onClose={() => setShowEditModal(false)}>
          <div className="modal">
            <h2>Edit Item</h2>
            <EditItemForm
              item={selectedItem}
              onSubmit={editItem}
              onDelete={() => handleDeleteItemClick(selectedItem.id)}
              onCancel={() => setShowEditModal(false)}
            />
          </div>
        </Popup>
      </div>
      <NavBars />
    </div>
  );
};

const NewItemForm = ({ onSubmit, onCancel }) => {
  const [name, setName] = useState('');
  const [image, setImage] = useState('');
  const [totalQuantity, setTotalQuantity] = useState(0);
  const [documentation, setDocumentation] = useState('');

  const handleSubmit = (e) => {
    e.preventDefault();
    onSubmit({ name, image, totalQuantity, documentation });
  };

  return (
    <form onSubmit={handleSubmit}>
      <div className="form-group">
        <label className='form-comp'>Name:</label>
        <input className='form-comp' type="text" value={name} onChange={(e) => setName(e.target.value)} />
      </div>
      <div className="form-group">
        <label className='form-comp'>Image URL:</label>
        <input className='form-comp' type="text" value={image} onChange={(e) => setImage(e.target.value)} />
      </div>
      <div className="form-group">
        <label className='form-comp'>Total Quantity:</label>
        <input className='form-comp' type="number" value={totalQuantity} onChange={(e) => setTotalQuantity(Number(e.target.value))} />
      </div>
      <div className="form-group">
        <label className='form-comp'>Documentation:</label>
        <input className='form-comp' value={documentation} onChange={(e) => setDocumentation(e.target.value)}></input>
      </div>
      <button type="submit" className='modal-button'>Add Item</button>
      <button type="button" className='modal-button' onClick={onCancel}>Cancel</button>
    </form>
  );
};

const EditItemForm = ({ item, onSubmit, onDelete, onCancel }) => {
  const [name, setName] = useState(item?.Name || '');
  const [image, setImage] = useState(item?.image || '');
  const [totalQuantity, setTotalQuantity] = useState(item?.TotalQuantity || 0);
  const [documentation, setDocumentation] = useState(item?.Documentation || '');

  const handleSubmit = (e) => {
    e.preventDefault();
    onSubmit(item.id, name, image, totalQuantity, documentation);
  };

  return (
    <form onSubmit={handleSubmit}>
      <div className="form-group">
        <label>Name:</label>
        <input type="text" value={name} onChange={(e) => setName(e.target.value)} />
      </div>
      <div className="form-group">
        <label>Image URL:</label>
        <input type="text" value={image} onChange={(e) => setImage(e.target.value)} />
      </div>
      <div className="form-group">
        <label>Total Quantity:</label>
        <input className='form-comp' type="number" value={totalQuantity} onChange={(e) => setTotalQuantity(Number(e.target.value))} />
      </div>
      <div className="form-group">
        <label>Documentation:</label>
        <input value={documentation} onChange={(e) => setDocumentation(e.target.value)}></input>
      </div>
      <button type="submit" className='modal-button'>Save Changes</button>
      <button type="button" className='modal-button' onClick={onCancel}>Cancel</button>
      <button type="button" className='modal-button delete' onClick={onDelete}>Delete Item</button>
    </form>
  );
};

export default Items;
